import { toast } from '../../../utils/notification';
import store from '../../../store/store';
import request from 'src/request/request';

export const copyURL = async () => {
  const currentTab = store.getState().workspaces.instances.find(instance => instance.isActive);

  try {
    const result = await request<any, any>(true, 'POST', 'services/share/save', { tabUuid: currentTab.uuid });

    if (!result) {
      toast.error('Failed to create copy link');
      return;
    }

    const copyUrl = window.location.origin + '/app/' + result;

    // 🔹 2. In Zwischenablage kopieren
    if (typeof navigator.clipboard === 'undefined') {
      const textArea = document.createElement('textarea');
      textArea.value = copyUrl;
      textArea.style.position = 'fixed';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy');
      } catch (err) {
        toast.error(`Failed to copy: ${copyUrl}`, err);
        throw err;
      }
      document.body.removeChild(textArea);
    } else {
      await navigator.clipboard.writeText(copyUrl);
    }

    toast.info('URL copied');
  } catch (err) {
    console.error('Error copying URL:', err);
    toast.error('Something went wrong creating the copy URL.');
  }
};
